import { useState, useEffect, createContext, useContext } from 'react';
import AuthContext from './AuthContext';
import api from './api';

// Auth Provider Component
const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('adminToken'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initAuth = async () => {
            if (token) {
                try {
                    const response = await api.getProfile(token);
                    if (response.success) {
                        setUser(response.data);
                    } else {
                        localStorage.removeItem('adminToken');
                        setToken(null);
                    }
                } catch (error) {
                    console.error('Auth init error:', error);
                    localStorage.removeItem('adminToken');
                    setToken(null);
                }
            }
            setLoading(false);
        };

        initAuth();
    }, [token]);

    const login = async (username, password) => {
        const response = await api.login(username, password);
        if (response.success) {
            const { token: newToken, admin } = response.data;
            localStorage.setItem('adminToken', newToken);
            setToken(newToken);
            setUser(admin);
            return { success: true };
        }
        return { success: false, error: response.error };
    };

    const logout = () => {
        localStorage.removeItem('adminToken');
        setToken(null);
        setUser(null);
    };

    const value = {
        user,
        token,
        loading,
        login,
        logout,
        isAuthenticated: !!user
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;